// @vendors
const moment = require('moment');

// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
// @constants
const actionTypes = require('../raConstants/actionTypes');
const { DATE_FORMAT_TIME_HORIZON_CHECK } = require('../raConstants/index');

const portfolioEvolutionSuccess = data => ({
    type: actionTypes.RA_PORTFOLIO_EVOLUTION_SUCCESS,
    payload: { data },
});

const portfolioEvolutionFailure = error => ({
    type: actionTypes.RA_PORTFOLIO_EVOLUTION_FAILURE,
    payload: { error },
});

const portfolioEvolutionInProgress = () => ({
    type: actionTypes.RA_PORTFOLIO_EVOLUTION_REQUEST,
});

const portfolioEvolutionChangeOption = value => ({
    type: actionTypes.RA_PORTFOLIO_EVOLUTION_CHANGE_OPTION,
    payload: { value },
});

const portfolioEvolutionChangeModalOption = value => ({
    type: actionTypes.RA_PORTFOLIO_EVOLUTION_CHANGE_MODAL_OPTION,
    payload: { value },
});

const requestPortfolioEvolution = (
    portfolioId,
    portfolioStartDate,
) => dispatch => {
    const params = {
        portfolioId,
    };
    const requestData = {
        query: {
            startDate: moment(portfolioStartDate).format(
                DATE_FORMAT_TIME_HORIZON_CHECK,
            ),
        },
    };

    dispatch(portfolioEvolutionInProgress());
    return APIGet(
        dispatch,
        apiURLBuilder.getURL('raPortfolioEvolution', params),
        requestData,
    )
        .then(response => {
            dispatch(portfolioEvolutionSuccess(response));
        })
        .catch(error => {
            if (error.error) {
                dispatch(portfolioEvolutionFailure(error));
            } else {
                throw error;
            }
        });
};

const portfolioEvolutionTotalsSuccess = data => ({
    type: actionTypes.RA_PORTFOLIO_EVOLUTION_TOTALS_SUCCESS,
    payload: { data },
});

const portfolioEvolutionTotalsFailure = error => ({
    type: actionTypes.RA_PORTFOLIO_EVOLUTION_TOTALS_FAILURE,
    payload: { error },
});

const portfolioEvolutionTotalsInProgress = () => ({
    type: actionTypes.RA_PORTFOLIO_EVOLUTION_TOTALS_REQUEST,
});

const requestPortfolioEvolutionTotals = portfolioStartDate => dispatch => {
    const requestData = {
        query: {
            startDate: moment(portfolioStartDate).format(
                DATE_FORMAT_TIME_HORIZON_CHECK,
            ),
        },
    };

    dispatch(portfolioEvolutionTotalsInProgress());
    return APIGet(
        dispatch,
        apiURLBuilder.getURL('raPortfolioEvolutionTotals'),
        requestData,
    )
        .then(response => {
            dispatch(portfolioEvolutionTotalsSuccess(response));
        })
        .catch(error => {
            if (error.error) {
                dispatch(portfolioEvolutionTotalsFailure(error));
            } else {
                throw error;
            }
        });
};

module.exports = {
    requestPortfolioEvolution,
    requestPortfolioEvolutionTotals,
    portfolioEvolutionChangeModalOption,
    portfolioEvolutionChangeOption,
};
